import React, { PureComponent } from "react";
import { Link } from "react-router-dom";

import * as Service from "../helpers";
import * as date from "../../../utils/date";
import Oils from "../../../common/Oils";
import Clock from "../../OilRequestPage/sub/Clock";

type Props = {
  request: any;
};

const noop = () => undefined;

class Request extends PureComponent<Props> {
  render() {
    const { request } = this.props;
    const backgroundColor = Service.getOilRequestStatusColor(request.status);
    return (

      <div className="requestContainer">
        <div className="column">
          {Service.getOilRequestTitleV2(request)}
        </div>

        <div className="column">
          <div className="requestContainer__value">
            <Oils oils={request.oils} />
          </div>
        </div>
        <div className="column">
          <div className="requestContainer__label">
            Asukoht
          </div>
          <div className="requestContainer__value">{request.county}</div>
        </div>
        <div className="column">
          <div className="requestContainer__label">
            Staatus
            <span className="ring" style={{ backgroundColor }}></span>
          </div>
          <div className="requestContainer__value">{Service.getOilRequestStatusName(request.status)}</div>
        </div>
        <div className="column">
          {request.status === "Active" && (
            <>
              <div className="requestContainer__label">Aega lõpuni</div>
              <div className="requestContainer__value">
                <Clock request={request} onUpdate={noop} />
              </div>
            </>
          )}
          {request.status !== 'Active' && (
            <>
              <div className="requestContainer__label">Hanke lõpp</div>
              <div className="requestContainer__value">{date.get_DD_MM_YYYY(request.endDatetime)}</div>
            </>
          )}
        </div>
        <div className="column">
          <div className="d-flex">
            <Link to={`/oil-requests/${request.id}`} className="btn btn-primary">
              Vaata lähemalt
            </Link>
          </div>
        </div>
      </div>

    );
  }
}

export default Request;
